import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'az-root',
  encapsulation: ViewEncapsulation.None,
  template:`<router-outlet></router-outlet>`,
  styleUrls: ['./app.component.scss'],
  providers: [ AuthService ]
})

export class AppComponent { }



// WEBPACK FOOTER //
// C:/Synergy/Projects/SFE/Synergy.UI/src/app/app.component.ts